export enum EventType {
  WEBINAR = 'WEBINAR',
  PRESENTIAL = 'PRESENTIAL',
  BOTH = 'BOTH',
}
